// api/services/impressiontags.ts
import { fetchCustomerResource, handleRequest } from '@/api';
import type { ImpressionTag } from '@/types';

interface CustomerRef {
    id: number;
}

interface ImpressionTagOperationResponse {
    message: string;
    booking_id: number;
    creative_ids_added: number[];
    creative_ids_removed: number[];
    total_impression_tags: number;
    summary: string;
}

export const getImpressionTagsForCustomer = (customer: CustomerRef, signal?: AbortSignal): Promise<ImpressionTag[]> =>
    fetchCustomerResource<ImpressionTag[]>('impressiontags', customer.id, signal);

export const getCreativeIdsForBooking = (bookingId: number): Promise<number[]> =>
    // Routed through handleRequest so chameleon X-Impersonate-* headers are carried —
    // a distributor/superuser wearing an entity must query its creative IDs, not their own.
    handleRequest<number[]>('get', `/impressiontags/booking/${bookingId}/creative-ids`);

export const saveBookingCreatives = (
    bookingId: number,
    creativeIds: number[]
): Promise<ImpressionTagOperationResponse> =>
    handleRequest<ImpressionTagOperationResponse>(
        'post',
        `/impressiontags/bulk/${bookingId}`,
        { creative_ids: creativeIds },
        'Impression tags configured successfully!'
    );
